import React, { useEffect, useState } from "react";
import "./video.scss";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { ArrowUpRight, PlayCircle, VideoOff } from "lucide-react";
import { fetchVideo } from "../../api/newsService";
import HoverVideoPlayer from "react-hover-video-player";

const Video = () => {
  const [page, setPage] = useState(0);
  const [postVideo, setPostVideo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getVideo = async () => {
    try {
      const res = await fetchVideo();
      if (res?.data?.data?.lstVideo?.length > 0) {
        setPostVideo(res.data.data.lstVideo);
      } else {
        setPostVideo([]);
      }
    } catch (error) {
      setPostVideo([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getVideo();
  }, []);

  const videos = postVideo;
  const videosPerPage = 6;
  const numberOfVideosVisited = page * videosPerPage;
  const totalPages = Math.ceil(videos.length / videosPerPage);

  const changePage = ({ selected }) => {
    setPage(selected);
  };

  return (
    <section className="video_media video_media--library">
      {isLoading ? (
        <div className="video_media__empty" role="status" aria-live="polite">
          <span className="video_media__empty-icon video_media__empty-icon--loading" />
          <h3>Đang tải video...</h3>
        </div>
      ) : videos.length === 0 ? (
        <div className="video_media__empty">
          <span className="video_media__empty-icon">
            <VideoOff size={42} />
          </span>
          <h3>Chưa có video được đăng tải</h3>
          <p>Các video mới sẽ được cập nhật tại đây.</p>
        </div>
      ) : (
        <div className="video_media__grid video_media__grid--video">
          {videos
            .slice(numberOfVideosVisited, numberOfVideosVisited + videosPerPage)
            .map((video) => (
              <Link key={video.id} to={`/thu-vien-video/${video.id}`} className="video_media__video-card">
                <div className="video_media__video-media">
                  <HoverVideoPlayer
                    videoSrc={video.videoPath}
                    pausedOverlay={<img src={video.image} alt={video.title} />}
                  />
                  <span className="video_media__video-play">
                    <PlayCircle size={22} />
                  </span>
                </div>

                <div className="video_media__video-body">
                  <h3>{video.title}</h3>
                  <span className="video_media__video-cta">
                    Xem video
                    <ArrowUpRight size={15} />
                  </span>
                </div>
              </Link>
            ))}
        </div>
      )}

      {totalPages > 1 && (
        <ReactPaginate
          previousLabel={"Trước"}
          nextLabel={"Sau"}
          pageCount={totalPages}
          onPageChange={changePage}
          containerClassName={"video_media__pagination"}
          previousLinkClassName={"video_media__page-link"}
          nextLinkClassName={"video_media__page-link"}
          disabledClassName={"video_media__page-disabled"}
          activeClassName={"video_media__page-active"}
          pageClassName={"video_media__page-item"}
          pageLinkClassName={"video_media__page-link"}
          previousClassName={"video_media__page-item"}
          nextClassName={"video_media__page-item"}
          breakClassName={"video_media__page-item"}
          breakLinkClassName={"video_media__page-link"}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          forcePage={page}
        />
      )}
    </section>
  );
};

export default Video;
